// 将url中的查询参数解析成对象
import * as Throttle from 'throttle-debounce';
export const urlParse = (url) => {
  url = url || window.location.search
  let obj = {}
  let reg = /[?&][^?&]+=[^?&]+/g
  let arr = url.match(reg)
  if (arr) {
    arr.forEach((item) => {
      let tempArr = item.slice(1).split('=')
      let key = decodeURIComponent(tempArr[0])
      obj[key] = decodeURIComponent((tempArr[1]))
    })
  }
  return obj
}

// 深拷贝
export const deepCopy = (obj) => {
  var result = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key])
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
export const debounce = (func, wait) => {
  return Throttle.debounce(wait, func);
}

/**
 * @desc 函数节流
 * @param func 目标函数
 * @param threshhold 延迟执行毫秒数
 * @param scope 指定上下文环境
 */
export const throttle = (fn, threshhold) => {
  threshhold || (threshhold = 100)
  return Throttle.throttle(threshhold, fn);
}

const hasOwn = Object.prototype.hasOwnProperty;
export const merge = function (target) {
  const args = Array.prototype.slice.call(arguments, 1);
  for (let i = 0; i < args.length; i++) {
    const source = args[i] || {};
    for(let key in source) {
      if (hasOwn.call(source, key) && source[key] !== undefined) {
        target[key] = source[key];
      }
    }
  }
  return target;
}


export const getviewportSize = function () {
  return window.innerHeight;
}



export function copy2Clipboard(content) {
  return new Promise((resolve, reject) => {
    const doc = document;
    const oInput = doc.createElement('textarea');
    oInput.style.position = 'fixed';
    oInput.style.top = '-9999px';
    oInput.style.left = '-9999px';
    oInput.style.visibility = 'hidden';
    oInput.value = content;
    doc.body.appendChild(oInput);
    try {

      oInput.select(); // 选择对象
      oInput.setSelectionRange(0, oInput.value.length);
      doc.execCommand("Copy"); // 执行浏览器复制命令
      doc.body.removeChild(oInput);
      resolve(oInput.value);
    } catch(e) {
      doc.body.removeChild(oInput);
      reject('error');
    }
  })
}


// 下划线转换驼峰
export function toHump (name) {
  return name.replace(/_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
// 驼峰转换下划线
export function toLine (name) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase();
}
